import { ApisauceInstance } from 'apisauce';

// POST /v1/driver_bonus/tags/add — adds `tag` to each record's userTags doc.
// Program/period/driver go in the query string; tags/records/data_type in the body.
const addBonusTag = ({
  api,
  bonusProgramId,
  period,
  driver,
  tag,
  recordIds,
  dataType,
  comment,
}: {
  api: ApisauceInstance;
  bonusProgramId: string;
  period: string;
  driver: string;
  tag: string;
  recordIds: string[];
  dataType: string;
  comment?: string;
}) => {
  return api.post<BonusTags.TagMutationResponse>(
    `/v1/driver_bonus/tags/add?driver_bonus_program_id=${bonusProgramId}&period=${period}&driver=${driver}`,
    {
      tags: [tag],
      records: recordIds,
      data_type: dataType,
      ...(comment ? { comment } : {}),
    },
  );
};

export default addBonusTag;
